import { FC } from "react";
import { Content, isFilled } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { VisibleSliceZone } from "@up/ui";
import type { SliceContext } from "../types";
import { components } from "../";

/**
 * Props for `ReusableContent`.
 */
export type ReusableContentProps = SliceComponentProps<
  Content.ReusableContentSlice,
  SliceContext
>;

/**
 * Component for "ReusableContent" Slices.
 */
const ReusableContent: FC<ReusableContentProps> = ({ slice, context }) => {
  const { reusableContentData } = context;
  const link = slice.primary.link;

  if (!isFilled.contentRelationship(link)) return null;

  const d = reusableContentData.find((item: any) => item.id === link.id);
  if (!d) return null;

  return (
    <VisibleSliceZone
      slices={d.data.body}
      components={components}
      context={context}
    />
  );
};

export default ReusableContent;
